const testimonials_component = document.getElementById("comp-testimonials");


if (testimonials_component) {
  init_testimonial_swiper();
  function init_testimonial_swiper() {
    //$ Assign the swiper container element
    const swiperEl = testimonials_component.querySelector(
      "swiper-container.testimonials"
    );

    //$ Exit function if the swiper element can't be found
    if (!swiperEl) {
      return;
    }

    const params = {
      slidesPerView: 1,
      loop: true,
      spaceBetween: 30,
      pagination: {
        type: "fraction",
      },
      navigation: {
        prevEl: testimonials_component.querySelector(".prev"),
        nextEl: testimonials_component.querySelector(".next"),
      },

      //# Injecting Styles into slider
      injectStyles: [
        `
          .swiper-pagination-current{
          font-weight: 700;
          }
          `,
      ],

      breakpoints: {
        0: {},
        1000: {},
        1300: {},
      },
      on: {
        init() {},
      },
    };

    //$ assign all parameters to Swiper element
    Object.assign(swiperEl, params);


    //$ initialize it
    if ( swiperEl.shadowRoot ) {
      swiperEl.initialize();
      // return;
    }
  }
}
